import { DevelopmentBar, Flex } from 'components'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import { getGoogleFont, loadFont } from 'utils'
import { EventProvider } from '../components/EventProvider'
import { useEvent } from '../utils'

export default function RootPage() {
  return (
    <EventProvider>
      <DevelopmentBar />
      <Content>
        <Outlet />
      </Content>
    </EventProvider>
  )
}

function Content({ children }: { children: React.ReactNode }) {
  const font = useFont()

  return (
    <Flex
      fontFamily={font}
      flex={1}
      direction="column"
      overflow="hidden"
      bg="rgba(220, 220, 220, 1)"
      gap={{ base: 0, sm: 7 }}
      pt={{ base: 'calc(env(safe-area-inset-top))', sm: 0 }}
      pb={{ base: 'calc(env(safe-area-inset-bottom))', sm: 0 }}
    >
      {children}
    </Flex>
  )
}

function useFont() {
  const event = useEvent()
  const [family, setFamily] = useState<string>('Inter')

  useEffect(() => {
    if (!event) return

    const family = event?.fontFamily || 'Inter'
    if (family === 'Inter') return

    getGoogleFont(family).then(f => {
      loadFont(f)
      setFamily(f.family)
    })
  }, [event])

  return family
}
